import TabPrograms from "./TabPrograms";
import TabAssignmentRules from "./TabAssignmentRules";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { Permission } from "~/hooks/permissions";
import TabsPage from "~/components/layout/TabsPage";

const PredictConfig = () => {
  const { loading } = useOrgConfig();

  return (
    <TabsPage
      basePath="predict-config"
      loading={loading}
      tabs={{
        programs: {
          label: "Programs",
          permission: Permission.debugApps,
          component: (id) => <TabPrograms id={id} />,
        },
        "assignment-rules": {
          label: "Assignment Rules",
          permission: Permission.manageOrgConfig,
          component: () => <TabAssignmentRules />,
        },
      }}
    />
  );
};

export default PredictConfig;
